












































import Vue from "vue";
import Component from "vue-class-component";
import { FactorActivity, FactorLevelOperator, RealFactorActivity } from "@/models/patient";
import { Prop, Model, Emit, Ref, Inject } from "vue-property-decorator";

@Component({})
export class FactorLevelInput extends Vue /*implements Validatable */ {
  hasError = false;
  shouldValidate: boolean = false;

  @Inject({ default: null })
  form: any;

  @Ref("textField")
  textField: any;

  @Prop({ default: "" })
  label!: string;

  @Prop({ default: true })
  clearable!: boolean;

  @Prop({ default: "" })
  error!: string;

  @Prop({ default: () => [] })
  rules!: Array<(v: any) => boolean>;

  @Prop({ required: true })
  @Model("change")
  value!: null | RealFactorActivity;

  /**
   * Keeps the local state of the fields.
   */
  private amount: string = "0";
  private internalType: number = 0;
  private factor: FactorActivity | null = null;

  private get localRules() {
    return [
      (v: string | undefined) => {
        if (this.isInvalidAmount) {
          return this.$t("validator.validPercentageRequired");
        }
        if (this.isInvalidType) {
          return this.$t("validator.typeRequired");
        }
        return true;
      },
      ...(this.rules || []).map(rule => rule(this.currentValue))
    ];
  }

  private get isInvalidType() {
    return this.amount === null || parseFloat(this.amount) === 0
      ? this.internalType !== 0
      : this.internalType === 0;
  }

  private get isInvalidAmount() {
    if (this.amount === null && this.internalType === 0) {
      return false;
    }
    const n = parseFloat(`${this.amount || 0}`);
    if (n === 0 && this.internalType === 0) {
      return false;
    }
    return n <= 0 || n >= 100;
  }

  private availableTypes: Array<{
    label: string;
    value: null | FactorLevelOperator;
  }> = [
    { label: "?", value: null },
    { label: "=", value: "eq" },
    { label: "<", value: "lte" }
  ];

  set type(value: null | FactorLevelOperator) {
    for (let i = 0; i < this.availableTypes.length; i++) {
      if (this.availableTypes[i].value === value) {
        this.internalType = i;
        return;
      }
    }
    this.internalType = 0;
  }

  get type() {
    return this.availableTypes[this.internalType].value;
  }

  get currentValue() {
    if (!this.type) {
      return null;
    }
    return {
      op: this.type,
      value: parseFloat(this.amount),
      factor: this.factor
    };
  }

  @Emit("change")
  onChange() {
    this.validate();
    return this.currentValue;
  }

  onClear(e: Event) {
    this.reset();
  }

  mounted() {
    this.type = (this.value || { op: null }).op;
    this.amount = `${(this.value || { value: 0 }).value}`;
    this.factor = (this.value || { factor: null }).factor;
    if (!this.shouldValidate) {
      this.resetValidation();
    }
    if (this.form) {
      this.form.register(this);
    }
    this.hasError = this.textField.hasError;
  }

  reset() {
    this.internalType = 0;
    this.amount = "0";
    this.factor = null;
    this.resetValidation();
    this.onChange();
  }

  resetValidation() {
    this.shouldValidate = false;
    this.textField.resetValidation();
  }

  validate(force: boolean = false, value?: any): boolean {
    this.shouldValidate = true;
    return this.textField.validate();
  }

  beforeDestroy() {
    if (this.form) {
      this.form.unregister(this);
    }
  }
}

export default FactorLevelInput;
